module.exports = __webpack_public_path__ + "img/header_logo.36de883e.jpg";